<template>
  <v-row no-gutters>
    <v-col cols="5">
      <v-sheet class="py-3">
        <div class="d-flex align-center">
          <v-icon icon="mdi-calendar-week" size="large"></v-icon>
          <p class="mx-3">Trvanie</p>
        </div>
      </v-sheet>
    </v-col>

    <v-col cols="7">
      <v-sheet class="py-3">
        <div v-if="!isOffice365Task" class="d-flex align-center mb-3">
          <v-icon
            class="add-date cursor-pointer mr-2"
            icon="mdi-plus"
            size="medium"
            @click="showModal = true"
          />
          <p class="task-badge rounded-pill">Pridať záznam</p>
        </div>

        <div
          v-for="(timeblock, index) in timeblocks"
          :key="timeblock.id || `timeblock-${index}`"
          class="timeblock-item mb-3"
        >
          <div class="d-flex align-center mb-2">
            <v-icon
              v-if="!isOffice365Task"
              class="circle-border cursor-pointer mr-2"
              icon="mdi-minus"
              size="medium"
              @click.stop="
                timeblock.id
                  ? deleteTimeblock(timeblock)
                  : deleteTimeblockByIndex(index)
              "
            />
            <p
              class="task-badge rounded-pill"
              :class="{ 'strike-through': timeblock.is_finished }"
            >
              {{ formatTimeblockStart(timeblock) }} -
              {{ formatTimeblockEnd(timeblock) }}
            </p>
            <v-icon
              v-if="!isOffice365Task"
              v-show="subtask.id"
              class="circle-border ml-2"
              :class="{
                completed: timeblock.is_finished,
                'cursor-pointer': !subtask.is_draft,
                'disabled-check': subtask.is_draft,
              }"
              icon="mdi-check"
              size="medium"
              @click.stop="
                !subtask.is_draft && toggleTimeblockIsFinished(timeblock, index)
              "
            />
          </div>

          <!-- Timeline Visualization for existing timeblock -->
          <!-- <div
            v-if="employee && timeblock.date"
            class="existing-timeblock-timeline ml-8"
          >
            <a-employee-timeblock-timeline
              :is-loading="getTimelineLoadingState(index)"
              :employee="employee"
              :scheduled-blocks="getScheduledBlocksForTimeblock(index)"
              :other-timeblocks="
                getOtherTimeblocksForTimeblock(timeblock, index)
              "
              :current-timeblock-range="getTimeblockRange(timeblock)"
              :collision="getCollisionForTimeblock(timeblock, index)"
              :collision-segments="
                getCollisionSegmentsForTimeblock(timeblock, index)
              "
              :timeblock-duration="calculateDuration(timeblock)"
              :start-hour="START_HOUR"
              :end-hour="END_HOUR"
              :hour-width="hourWidth"
            />
          </div> -->
        </div>
      </v-sheet>
    </v-col>
  </v-row>

  <v-dialog
    v-model="showModal"
    :width="modalWidth"
    :height="modalHeight"
    persistent
    :retain-focus="false"
  >
    <v-card
      style="position: relative; height: 100%; max-height: calc(100vh - 48px)"
      class="add-timeblock-modal"
    >
      <div class="d-flex justify-space-between align-center pa-4">
        <h1>Pridať dátum</h1>
        <div class="d-flex align-start">
          <a-reset-size-button @reset="resetModalSize" />
          <a-close-button @close="closeModal()" />
        </div>
      </div>

      <v-card-text class="pa-4">
        <!-- Reuse the a-employee-timeblock component -->
        <a-employee-timeblock
          ref="employeeTimeblockRef"
          v-model="newTimeblock"
          :employee="employee"
          :deletable="false"
          :index="0"
          :draft-timeblocks="draftTimeblocks"
        />
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-btn class="button primary" @click="submitFromEmployeeTimeblock()">
          Potvrdiť
        </v-btn>
      </v-card-actions>
      <a-resize-handle
        :current-width="modalWidthPx"
        :current-height="modalHeightPx"
        @resize="handleModalResize"
        @resize-end="handleResizeEnd"
      />
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="visible"
    :width="modalWidth"
    :height="modalHeight"
    persistent
    :retain-focus="false"
  >
    <v-card
      style="position: relative; height: 100%; max-height: calc(100vh - 48px)"
    >
      <div class="d-flex justify-space-between align-center">
        <h1 class="text-red">
          Ste si istý, že chcete pridať timeblock po deadline <br />
          <b class="text-black">z mastertasku {{ subtask?.project_code }} ?</b>
        </h1>

        <div class="d-flex align-start">
          <a-reset-size-button @reset="resetModalSize" />
          <a-close-button @close="closeModal()" />
        </div>
      </div>
      <v-card-actions
        class="mt-10 d-flex justify-start align-center mobile-view"
      >
        <v-btn
          class="button primary half"
          variant="flat"
          @click.stop="confirmSubmit()"
          >ÁNO</v-btn
        >
        <v-btn class="button primary half outline" @click.stop="closeModal()"
          >ZRUŠIŤ</v-btn
        >
      </v-card-actions>
      <a-resize-handle
        :current-width="modalWidthPx"
        :current-height="modalHeightPx"
        @resize="handleModalResize"
        @resize-end="handleResizeEnd"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import tmUtils from '@/plugins/tm@_utils/tm.utils';
import moment from 'moment';
import modalMixin from '@/plugins/tm@modal/_mixins/modal.mixin';
import { mapGetters } from 'vuex';
import AEmployeeTimeblock from '../employees/a-employee-timeblock.vue';
// import AEmployeeTimeblockTimeline from '../employees/a-employee-timeblock-timeline.vue';
import {
  timeblockToDateRange,
  detectCollision,
  getCollisionSegments,
  calculateTimeblockDuration,
} from '@/plugins/tm@_utils/timeblock.utils';
import AResetSizeButton from '@/plugins/tm@modal/_components/a-reset-size-button.vue';
import ACloseButton from '@/plugins/tm@modal/_components/a-close-button.vue';
import AResizeHandle from '@/plugins/tm@modal/_components/a-resize-handle.vue';

export default {
  components: {
    AEmployeeTimeblock,
    // AEmployeeTimeblockTimeline,
    AResetSizeButton,
    ACloseButton,
    AResizeHandle,
  },
  mixins: [modalMixin],

  props: {
    timeblocks: {
      type: Array,
      required: true,
    },

    subtask: {
      type: Object,
      required: true,
    },

    isDraft: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update-subtask'],

  data() {
    return {
      tmUtils,
      showModal: false,
      visible: false,
      // New timeblock for modal (used by a-employee-timeblock component)
      newTimeblock: {
        id: null,
        date: new Date(),
        starts_at_time: null,
        ends_at_time: null,
        employee_id: null,
      },
      // Timeline constants
      START_HOUR: 0,
      END_HOUR: 24,
      HOUR_WIDTH: 60,
      HOUR_WIDTH_MOBILE: 50,
      // Existing timeblocks timeline data
      existingTimeblocksData: {}, // { [index]: { tasks: [], loading: false } }
      modalName: 'a-task-timeblocks-modal',
      modalSize: 'medium',
    };
  },

  computed: {
    ...mapGetters('tm', ['mastertasks', 'enrichedEmployees']),

    isOffice365Task() {
      return this.subtask.type == 'office365';
    },

    // Get employee data from subtask
    employee() {
      if (!this.subtask?.employee_id) return null;
      return (
        this.subtask._employee ||
        this.enrichedEmployees.find(
          (emp) => emp.id === this.subtask.employee_id,
        )
      );
    },

    // Get draft timeblocks for the current employee in backend format for timeline
    draftTimeblocks() {
      if (!this.isDraft) {
        return [];
      }

      // Convert timeblocks from internal format to backend format for timeline
      return this.timeblocks
        .filter((tb) => tb.date && tb.starts_at_time && tb.ends_at_time)
        .map((tb) => {
          const dateStr = moment(tb.date).format('YYYY-MM-DD');
          return {
            ...tb,
            start: `${dateStr} ${tb.starts_at_time}:00`,
            end: `${dateStr} ${tb.ends_at_time}:00`,
            employee_id: this.subtask.employee_id,
          };
        });
    },

    // Hour width based on screen size
    hourWidth() {
      return window.innerWidth <= 768
        ? this.HOUR_WIDTH_MOBILE
        : this.HOUR_WIDTH;
    },

    // Computed property to trigger reactivity when existingTimeblocksData changes
    existingTimeblocksDataReactive() {
      // This forces Vue to track changes to existingTimeblocksData
      return { ...this.existingTimeblocksData };
    },
  },

  watch: {
    // Watch for timeblocks changes
    timeblocks: {
      handler() {
        // Refetch timeline data for all timeblocks when they change
        this.$nextTick(() => {
          this.fetchAllTimelinesData();
        });
      },
      deep: true,
    },
    // Watch for employee changes
    'employee.id': {
      handler(newId) {
        if (newId) {
          this.fetchAllTimelinesData();
        }
      },
    },
    // Watch for modal opening - set employee_id and reset to today
    showModal: {
      handler(isOpen) {
        if (isOpen) {
          this.newTimeblock = {
            id: null,
            date: new Date(),
            starts_at_time: null,
            ends_at_time: null,
            employee_id: this.employee?.id || null,
          };
        }
      },
    },
  },

  mounted() {
    // Fetch timeline data on mount
    if (this.employee?.id) {
      this.fetchAllTimelinesData();
    }
  },

  methods: {
    // Submit timeblock from employee timeblock component
    async submitFromEmployeeTimeblock() {
      // Validate using the employee timeblock component's validation
      const isValid = await this.$refs.employeeTimeblockRef?.validate();

      if (!isValid) {
        return;
      }

      // The newTimeblock data is already reactive and updated by the component
      await this.submit();
    },

    // Methods for existing timeblocks timeline
    getTimelineLoadingState(index) {
      const reactiveData = this.existingTimeblocksDataReactive;
      return reactiveData[index]?.loading || false;
    },

    getScheduledBlocksForTimeblock(index) {
      // Use the reactive computed property to ensure Vue tracks changes
      const reactiveData = this.existingTimeblocksDataReactive;
      const tasks = reactiveData[index]?.tasks || [];
      const currentTimeblock = this.timeblocks[index];

      // Filter out the current timeblock from scheduled blocks
      return tasks.filter(
        (task) =>
          !task._timeblock_id ||
          !currentTimeblock.id ||
          task._timeblock_id !== currentTimeblock.id,
      );
    },

    getOtherTimeblocksForTimeblock(timeblock, currentIndex) {
      if (!timeblock.date) return [];

      const selectedDate = moment(timeblock.date).format('YYYY-MM-DD');

      return this.timeblocks.filter((tb, idx) => {
        // Skip current timeblock
        if (idx === currentIndex) return false;

        if (!tb.date || !tb.starts_at_time || !tb.ends_at_time) return false;
        const tbDate = moment(tb.date).format('YYYY-MM-DD');
        return tbDate === selectedDate;
      });
    },

    getTimeblockRange(timeblock) {
      const { start, end } = timeblockToDateRange(timeblock);
      return { start, end };
    },

    getCollisionForTimeblock(timeblock, index) {
      const scheduledBlocks = this.getScheduledBlocksForTimeblock(index);
      return detectCollision(timeblock, scheduledBlocks);
    },

    getCollisionSegmentsForTimeblock(timeblock, index) {
      const scheduledBlocks = this.getScheduledBlocksForTimeblock(index);
      return getCollisionSegments(timeblock, scheduledBlocks);
    },

    calculateDuration(timeblock) {
      return calculateTimeblockDuration(timeblock);
    },

    async fetchTimelineDataForTimeblock(index) {
      const timeblock = this.timeblocks[index];

      if (!this.employee?.id || !timeblock.date) {
        this.existingTimeblocksData = {
          ...this.existingTimeblocksData,
          [index]: {
            tasks: [],
            loading: false,
          },
        };
        return;
      }

      this.existingTimeblocksData = {
        ...this.existingTimeblocksData,
        [index]: {
          tasks: this.existingTimeblocksData[index]?.tasks || [],
          loading: true,
        },
      };

      try {
        const dateStr = moment(timeblock.date).format('YYYY-MM-DD');
        const queryParams = new URLSearchParams({
          start: dateStr,
          end: dateStr,
          employee_id: this.employee.id.toString(),
        }).toString();

        const response = await this.$axios.get_auth(
          `v1/subtasks?${queryParams}`,
        );

        const subtasks = [
          ...(response.subtasks || []),
          ...(response.blockers || []),
        ];

        const tasks = [];

        subtasks.forEach((subtask) => {
          // Check if this is a blocker/adhoc/etc with direct start/end fields (no timeblocks array)
          if (
            !subtask.timeblocks &&
            subtask.start &&
            subtask.end &&
            [
              'blocker',
              'adhoc',
              'home_office',
              'vacation',
              'free_day',
              'office365_blocker',
            ].includes(subtask.type)
          ) {
            const blockerDateStr = moment(subtask.start).format('YYYY-MM-DD');

            if (blockerDateStr === dateStr) {
              const type = subtask.type;

              tasks.push({
                id: subtask.id,
                start: new Date(subtask.start),
                end: new Date(subtask.end),
                master_task: null,
                date: new Date(subtask.start),
                project_code: null,
                subtask: subtask,
                blocker: subtask,
                type,
                _timeblock_id: null,
                _timeblock_is_finished: subtask.is_finished || false,
                _real_start: new Date(subtask.start),
                _real_end: new Date(subtask.end),
              });
            }
          } else {
            // Process regular subtasks with timeblocks array
            subtask.timeblocks?.forEach((tb) => {
              const timeblockDateStr = moment(tb.start).format('YYYY-MM-DD');

              if (timeblockDateStr === dateStr) {
                let type = 'subtask';
                if (subtask.type === 'office365') type = 'office365';

                tasks.push({
                  id: subtask.id,
                  start: new Date(tb.start),
                  end: new Date(tb.end),
                  master_task: subtask.master_task,
                  date: new Date(tb.start),
                  project_code: subtask.project_code,
                  subtask: subtask,
                  blocker: undefined,
                  type,
                  _timeblock_id: tb.id,
                  _timeblock_is_finished: tb.is_finished,
                  _real_start: new Date(tb.start),
                  _real_end: new Date(tb.end),
                });
              }
            });
          }
        });

        this.existingTimeblocksData = {
          ...this.existingTimeblocksData,
          [index]: {
            tasks,
            loading: false,
          },
        };
      } catch (error) {
        console.error('Error fetching timeline data for timeblock:', error);
        this.existingTimeblocksData = {
          ...this.existingTimeblocksData,
          [index]: {
            tasks: [],
            loading: false,
          },
        };
      }
    },

    // Fetch timeline data for all existing timeblocks
    async fetchAllTimelinesData() {
      if (!this.employee?.id) return;

      const promises = this.timeblocks.map((_, index) =>
        this.fetchTimelineDataForTimeblock(index),
      );

      await Promise.all(promises);
    },

    formatTimeblockStart(timeblock) {
      // Handle internal format with date and time fields
      if (timeblock.date && timeblock.starts_at_time) {
        const dateStr = moment(timeblock.date).format('DD.MM.yyyy');
        return `${dateStr}, ${timeblock.starts_at_time}`;
      }
      // Fallback to backend format
      if (timeblock.start) {
        return tmUtils.formatDateTime(timeblock.start);
      }
      return '';
    },

    formatTimeblockEnd(timeblock) {
      // Handle internal format with date and time fields
      if (timeblock.date && timeblock.ends_at_time) {
        return timeblock.ends_at_time;
      }
      // Fallback to backend format
      if (timeblock.end) {
        return tmUtils.formatDateTime(timeblock.end);
      }
      return '';
    },

    async submit() {
      const subtask = JSON.parse(JSON.stringify(this.subtask));

      if (!subtask?.timeblocks) {
        subtask.timeblocks = [];
      }
      if (!subtask?.timesheets) {
        subtask.timesheets = [];
      }
      if (!subtask?.is_finished) {
        subtask.is_finished = 0;
      }

      const newTimeblockData = {
        id: null,
        date: this.newTimeblock.date,
        starts_at_time: this.newTimeblock.starts_at_time,
        ends_at_time: this.newTimeblock.ends_at_time,
        is_finished: 0,
      };

      // For drafts with employees array, add to the correct employee's timeblocks
      if (subtask.is_draft && Array.isArray(subtask.employees)) {
        const employeeIndex = subtask.employees.findIndex(
          (emp) => emp.id == this.subtask.employee_id,
        );
        if (employeeIndex !== -1) {
          if (!subtask.employees[employeeIndex].timeblocks) {
            subtask.employees[employeeIndex].timeblocks = [];
          }
          subtask.employees[employeeIndex].timeblocks.push(newTimeblockData);
        }
      } else {
        // For published subtasks, add to root timeblocks
        subtask.timeblocks.push(newTimeblockData);
      }

      if (subtask.deadline)
        subtask.deadline = tmUtils.formatDateTimeForBackend(
          this._mergeDeadlineTimeDate(),
        );

      const isAfterDeadline = this.isAfterDeadline();

      if (isAfterDeadline) {
        this.visible = true;
      } else {
        if (!subtask.id) {
          this.$emit('update-unfinished-subtask', subtask);
          this.closeModal();
        } else {
          this._update(subtask);
        }
      }
    },

    async confirmSubmit() {
      const subtask = JSON.parse(JSON.stringify(this.subtask));

      if (!subtask?.timeblocks) {
        subtask.timeblocks = [];
      }
      if (!subtask?.timesheets) {
        subtask.timesheets = [];
      }
      if (!subtask?.is_finished) {
        subtask.is_finished = 0;
      }

      const newTimeblockData = {
        id: null,
        date: this.newTimeblock.date,
        starts_at_time: this.newTimeblock.starts_at_time,
        ends_at_time: this.newTimeblock.ends_at_time,
        is_finished: 0,
      };

      // For drafts with employees array, add to the correct employee's timeblocks
      if (subtask.is_draft && Array.isArray(subtask.employees)) {
        const employeeIndex = subtask.employees.findIndex(
          (emp) => emp.id == this.subtask.employee_id,
        );
        if (employeeIndex !== -1) {
          if (!subtask.employees[employeeIndex].timeblocks) {
            subtask.employees[employeeIndex].timeblocks = [];
          }
          subtask.employees[employeeIndex].timeblocks.push(newTimeblockData);
        }
      } else {
        // For published subtasks, add to root timeblocks
        subtask.timeblocks.push(newTimeblockData);
      }

      if (subtask.deadline)
        subtask.deadline = tmUtils.formatDateTimeForBackend(
          this._mergeDeadlineTimeDate(),
        );

      if (!subtask.id) {
        this.$emit('update-unfinished-subtask', subtask);
        this.closeModal();
        return;
      }

      this.visible = false;
      this._update(subtask);
    },

    async toggleTimeblockIsFinished(originalTimeblock, _index) {
      // Only works for published subtasks with saved timeblocks
      if (!originalTimeblock.id) {
        return;
      }

      const subtask = JSON.parse(JSON.stringify(this.subtask));
      const timeblock = JSON.parse(JSON.stringify(originalTimeblock));

      timeblock.is_finished = timeblock.is_finished == 1 ? 0 : 1;

      try {
        // Convert timeblock to backend format before sending
        const timeblockForBackend = {
          id: timeblock.id,
          is_finished: timeblock.is_finished,
        };

        // If timeblock is in internal format, convert it
        if (timeblock.date) {
          const dateStr = moment(timeblock.date).format('YYYY-MM-DD');
          timeblockForBackend.start = `${dateStr} ${timeblock.starts_at_time}:00`;
          timeblockForBackend.end = `${dateStr} ${timeblock.ends_at_time}:00`;
        } else {
          // Already in backend format
          timeblockForBackend.start = timeblock.start;
          timeblockForBackend.end = timeblock.end;
        }

        const { data: newTimeblock } = await this.$axios.put_auth(
          `v1/timeblocks/${timeblock.id}`,
          timeblockForBackend,
        );

        // Convert returned timeblock from backend format to internal format
        const startMoment = moment(newTimeblock.start, 'YYYY-MM-DD HH:mm:ss');
        const endMoment = moment(newTimeblock.end, 'YYYY-MM-DD HH:mm:ss');
        const convertedTimeblock = {
          id: newTimeblock.id,
          date: startMoment.toDate(),
          starts_at_time: startMoment.format('HH:mm'),
          ends_at_time: endMoment.format('HH:mm'),
          is_finished: newTimeblock.is_finished,
        };

        // Update timeblock in correct location (employee's array for drafts, root for published)
        if (subtask.is_draft && Array.isArray(subtask.employees)) {
          const employeeIndex = subtask.employees.findIndex(
            (emp) => emp.id == this.subtask.employee_id,
          );
          if (employeeIndex !== -1) {
            subtask.employees[employeeIndex].timeblocks = subtask.employees[
              employeeIndex
            ].timeblocks.map((tb) => {
              if (tb.id == convertedTimeblock.id) return convertedTimeblock;
              return tb;
            });
          }
        } else {
          subtask.timeblocks = subtask.timeblocks.map((tb) => {
            if (tb.id == convertedTimeblock.id) return convertedTimeblock;
            return tb;
          });
        }

        this.$events.emit('on-subtask-edited', subtask);
        this.$emit('update-subtask', subtask);

        if (timeblock.is_finished)
          this.$events.emit('show-task-add-time-modal', { subtask });
      } catch (error) {
        this.$toast.error(error.message || error);
      }
    },

    async deleteTimeblock({ id }) {
      const subtask = JSON.parse(JSON.stringify(this.subtask));

      // Remove timeblock from correct location (employee's array for drafts, root for published)
      if (subtask.is_draft && Array.isArray(subtask.employees)) {
        // Find which employee this timeblock belongs to by searching through all employees
        let found = false;
        subtask.employees = subtask.employees.map((emp) => {
          if (!emp.timeblocks) return emp;

          // Check if this employee has the timeblock
          const hasTimeblock = emp.timeblocks.some((tb) => tb.id == id);
          if (hasTimeblock) {
            found = true;
            return {
              ...emp,
              timeblocks: emp.timeblocks.filter((tb) => tb.id != id),
            };
          }
          return emp;
        });

        if (!found) {
          console.warn('Timeblock not found in any employee', id);
        }
      } else {
        subtask.timeblocks = subtask.timeblocks.filter(
          (timeblock) => timeblock.id != id,
        );
      }

      if (subtask.deadline)
        subtask.deadline = tmUtils.formatDateTimeForBackend(
          this._mergeDeadlineTimeDate(),
        );

      this._update(subtask);
    },

    async deleteTimeblockByIndex(index) {
      const subtask = JSON.parse(JSON.stringify(this.subtask));

      // Remove timeblock by index from correct location
      if (subtask.is_draft && Array.isArray(subtask.employees)) {
        const employeeIndex = subtask.employees.findIndex(
          (emp) => emp.id == this.subtask.employee_id,
        );
        if (
          employeeIndex !== -1 &&
          subtask.employees[employeeIndex].timeblocks
        ) {
          subtask.employees[employeeIndex].timeblocks.splice(index, 1);
        }
      } else {
        subtask.timeblocks.splice(index, 1);
      }

      if (subtask.deadline)
        subtask.deadline = tmUtils.formatDateTimeForBackend(
          this._mergeDeadlineTimeDate(),
        );

      if (!subtask.id) {
        this.$emit('update-unfinished-subtask', subtask);
      } else {
        this._update(subtask);
      }
    },

    async _update(data) {
      try {
        const timesheets = data.timesheets.map((timesheet) => {
          delete timesheet.employee_name;
          return timesheet;
        });

        const payload = { ...data, timesheets };

        // For drafts with employees array, properly structure the employees with their timeblocks
        if (data.is_draft && Array.isArray(data.employees)) {
          const validEmployees = data.employees
            .filter((emp) => emp.id)
            .map((emp) => ({
              id: emp.id,
              duration: emp.duration,
              // Convert employee timeblocks to BE format
              timeblocks: (emp.timeblocks || [])
                .filter((tb) => tb.date || tb.start)
                .map((tb) => {
                  if (tb.start && !tb.date) {
                    return {
                      id: tb.id || null,
                      start: tb.start,
                      end: tb.end,
                      is_finished: tb.is_finished || 0,
                    };
                  }
                  const dateStr = moment(tb.date).format('YYYY-MM-DD');
                  return {
                    id: tb.id || null,
                    start: `${dateStr} ${tb.starts_at_time}:00`,
                    end: `${dateStr} ${tb.ends_at_time}:00`,
                    is_finished: tb.is_finished || 0,
                  };
                }),
            }));

          payload.employees = validEmployees;
          // For drafts, don't send root-level timeblocks
          delete payload.timeblocks;
        } else {
          // For published subtasks, convert and send root-level timeblocks
          const timeblocks = (data.timeblocks || [])
            .filter((timeblock) => {
              // Filter timeblocks that have either old format (date) or new format (start)
              return timeblock.date || timeblock.start;
            })
            .map((timeblock) => {
              // If already in BE format (has start field), return as is
              if (timeblock.start && !timeblock.date) {
                return {
                  id: timeblock.id || null,
                  start: timeblock.start,
                  end: timeblock.end,
                  is_finished: timeblock.is_finished || 0,
                };
              }

              // Convert from internal format to BE format
              const dateStr = moment(timeblock.date).format('YYYY-MM-DD');
              return {
                id: timeblock.id || null,
                start: `${dateStr} ${timeblock.starts_at_time}:00`,
                end: `${dateStr} ${timeblock.ends_at_time}:00`,
                is_finished: timeblock.is_finished || 0,
              };
            });

          payload.timeblocks = timeblocks;
        }

        // Remove UI-only enriched fields
        delete payload._created_by;
        delete payload._employee;
        delete payload._master_task;
        delete payload._deadline_time;

        const { subtask } = await this.$axios.put_auth(
          `v1/subtasks/${data.id}`,
          payload,
        );

        this.closeModal();
        this.$events.emit('on-subtask-edited', subtask);
      } catch (error) {
        this.$toast.error(error.message || error);
      }
    },

    isAfterDeadline() {
      const deadline = this.getDeadline(this.subtask);

      if (!deadline) return;

      const mDate = moment(this.newTimeblock.date);
      const mDeadline = moment(deadline);

      const [hours, minutes] = this.newTimeblock.ends_at_time
        .split(':')
        .map(Number);

      mDate.hours(hours);
      mDate.minutes(minutes);

      return mDate.isAfter(mDeadline);
    },

    getDeadline(subtask) {
      if (subtask?.deadline) return subtask.deadline;

      return subtask.master_task_deadline;
    },

    _mergeDeadlineTimeDate() {
      const date = new Date(this.subtask.deadline);
      const timeParts = this.subtask._deadline_time.split(':');

      date.setHours(parseInt(timeParts[0]));
      date.setMinutes(parseInt(timeParts[1]));

      return date;
    },

    closeModal() {
      // Reset newTimeblock
      this.newTimeblock = {
        id: null,
        date: new Date(),
        starts_at_time: null,
        ends_at_time: null,
        employee_id: this.employee?.id || null,
      };

      this.showModal = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.completed
  background: #06dece

.disabled-check
  opacity: 0.5
  cursor: not-allowed

.existing-timeblock-timeline
  margin-top: 8px
  padding-left: 16px

// Modal specific styles
.add-timeblock-modal
  ::v-deep
    // Hide employee select and add/remove buttons (user will handle with CSS later)
    .timeblock__header__top
      display: none

    .actions
      display: none
</style>
